import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100vw","height":"100vh","display":"flex","align-items":"center","justify-content":"center","flex-direction":"column"} }

import { Button, Space, Alert } from "ant-design-vue";
import { usePresenter } from "./presenter";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const presenter = usePresenter();
const { model } = presenter;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Space), null, {
      default: _withCtx(() => [
        _createVNode(_unref(Button), {
          onClick: _unref(presenter).handleGetMac
        }, {
          default: _withCtx(() => [
            _createTextVNode("获取 mac 地址")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_unref(Button), {
          onClick: _unref(presenter).handleMinimi
        }, {
          default: _withCtx(() => [
            _createTextVNode("最小化窗口")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_unref(Button), {
          onClick: _unref(presenter).handleMaximize
        }, {
          default: _withCtx(() => [
            _createTextVNode("最大化窗口")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_unref(Button), {
          onClick: _unref(presenter).handleLockScreen
        }, {
          default: _withCtx(() => [
            _createTextVNode("锁屏")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_unref(Button), {
          onClick: _unref(presenter).handleRoute
        }, {
          default: _withCtx(() => [
            _createTextVNode("路由跳转")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_unref(Button), {
          onClick: _unref(presenter).handleOpen
        }, {
          default: _withCtx(() => [
            _createTextVNode("新标签页")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_unref(model).mac.value)
      ? (_openBlock(), _createBlock(_unref(Alert), {
          key: 0,
          style: {"margin-top":"10px"},
          message: `mac 地址: ${_unref(model).mac.value}`,
          type: "info"
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ]))
}
}

})